export enum BlackList {
  SELECT_SITE = 'News API',
}
